class MultiquoteCoverage {
    constructor({
        coverageId,
        quoteId,
        clusterCode,
        insuranceCompany,
        insuranceCompanyDisplayName,
        insuranceCompanyDisplayLongName,
        insuranceCompanyLogo,
        insuranceCompanyLogoSmall,
        insuranceCompanyLogoGrey,
        shortName,
        longName,
        subscriptionAmount,
        commission,
        commissionAmount,
        status,
        createdAt,
        budget,
        error,
        emission,
    }) {
        this.coverageId = coverageId
        this.id = coverageId
        this.quoteId = quoteId
        this.clusterCode = clusterCode
        this.insuranceCompany = insuranceCompany
        this.insuranceCompanyDisplayName = insuranceCompanyDisplayName
        this.insuranceCompanyDisplayLongName = insuranceCompanyDisplayLongName
        this.insuranceCompanyLogo = insuranceCompanyLogo
        this.insuranceCompanyLogoSmall = insuranceCompanyLogoSmall
        this.insuranceCompanyLogoGrey = insuranceCompanyLogoGrey
        this.shortName = shortName
        this.longName = longName
        this.name = longName
        this.subscriptionAmount = subscriptionAmount
        this.commission = commission
        this.commissionPercentage = commission
        this.commissionAmount = commissionAmount
        this.status = status
        this.createdAt = createdAt
        this.budget = budget ?? {}
        this.error = error
        this.emission = emission
    }

    static fromGroupedItem(insuranceCompany, item) {
        const { insuranceCompanyLogos } = insuranceCompany

        return new MultiquoteCoverage({
            coverageId: item.id,
            quoteId: item.quoteId,
            clusterCode: item.clusterCode,
            insuranceCompany: insuranceCompany.name,
            insuranceCompanyDisplayName: insuranceCompany.displayName,
            insuranceCompanyDisplayLongName: insuranceCompany.displayLongName,
            insuranceCompanyLogo: insuranceCompanyLogos?.logo ?? null,
            insuranceCompanyLogoSmall: insuranceCompanyLogos?.small ?? null,
            insuranceCompanyLogoGrey: insuranceCompanyLogos?.grey ?? null,
            shortName: item.shortName,
            longName: item.longName,
            subscriptionAmount: item.subscriptionAmount ?? null,
            commission: item.commission ?? null,
            commissionAmount: item.commissionAmount ?? null,
            status: item.status ?? null,
            createdAt: item.createdAt ?? null,
            budget: item.budget ?? {},
            error: item.error ?? null,
            emission: item.emission ?? null,
        })
    }
}

export default MultiquoteCoverage
